

import React from "react";
import { Link } from "react-router-dom";
import BackgroundWrapper from "../components/BackgroundWrapper";


export default function EnlightenedLeadership() {
  return (
    <BackgroundWrapper>
      

      <div className="pt-8 pb-20 px-4 min-h-screen">
        <div className="max-w-5xl mx-auto">
          <Link
            to="/programs"
            className="text-blue-600 hover:text-blue-700 font-semibold inline-flex items-center mb-8"
          >
            ← Back to Programs
          </Link>

          <div className="bg-white/90 backdrop-blur-md rounded-3xl shadow-2xl p-10 md:p-16">
            <h1 className="text-xl sm:text-2xl md:text-5xl font-bold text-slate-800 mb-8 text-center">
              Enlightened Leadership
            </h1>

            <p className="sm:text-lg text-sm text-slate-700 mb-12 leading-relaxed text-center">
              This comprehensive program explores{" "}
              <strong>leadership, ethics, and societal impact.</strong> It enables
              leaders to move from success to significance through
              self-awareness, moral reflection, and purposeful action.
            </p>

            <h2 className="text-xl sm:text-2xl font-bold text-slate-800 mb-8 text-center">
              Series Overview
            </h2>

            {/* 🔹 Series Cards */}
            <div className="grid md:grid-cols-3 gap-8 mb-12">
              {/* Series 1 */}
              <Link
                to="/series-1"
                className="bg-gradient-to-br from-blue-50 to-indigo-50 p-6 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1"
              >
                <h3 className="text-sm sm:text-xl font-semibold text-blue-700 mb-3">
                  Series 1 – The Challenge of Leadership
                </h3>
                <p className="text-slate-700 text-sm mb-3">
                  Leadership style, ethics, and values.
                </p>
                <span className="text-blue-600 font-semibold text-sm">
                  Learn More →
                </span>
              </Link>

              {/* Series 2 */}
              <Link
                to="/series-2"
                className="bg-gradient-to-br from-indigo-50 to-purple-50 p-6 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1"
              >
                <h3 className="text-sm sm:text-xl font-semibold text-indigo-700 mb-3">
                  Series 2 – Leadership and the Good Society
                </h3>
                <p className="text-slate-700 text-sm mb-3">
                  Liberty, equity, efficiency, and sustainability.
                </p>
                <span className="text-indigo-600 font-semibold text-sm">
                  Learn More →
                </span>
              </Link>

              {/* Series 3 */}
              <Link
                to="/series-3"
                className="bg-gradient-to-br from-purple-50 to-pink-50 p-6 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1"
              >
                <h3 className="text-sm sm:text-xl font-semibold text-purple-700 mb-3">
                  Series 3 – Purpose and Personal Growth
                </h3>
                <p className="text-slate-700 text-sm mb-3">
                  Happiness, meaning, and the leader’s role in shaping the world.
                </p>
                <span className="text-purple-600 font-semibold text-sm">
                  Learn More →
                </span>
              </Link>
            </div>

            <p className="text-slate-700 leading-relaxed text-center">
              Each stage integrates seminars, group coaching, and individual
              mentoring. Leaders complete the journey equipped with a deep sense
              of purpose, integrity, and a refined moral compass.
            </p>
          </div>
        </div>
      </div>
    </BackgroundWrapper>
  );
}
